import { Menu } from "primereact/menu";
import { Button } from "primereact/button";
import { useState } from "react";
import styles from "./dropdownMenu.module.css";

const DropdownMenu = ({ icon, title, menu, items }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <>
      {items.length > 0 && (
        <>
          <Menu
            model={items}
            popup
            // popupAlignment="left"
            hidden={isVisible}
            ref={menu}
            id="popup_menu_right"
            className={`col-12 mt-3 ${styles.dropdownMenu}`}
            // onBlur={() => {
            //   alert("blur");
            // }}
           
          />
          <Button
            label={title}
            className={`col-3 ${styles.dropdownButton}`}
            size="small"
            icon={icon}
            onClick={(event) => {
              menu.current.toggle(event);
            }}
          />
        </>
      )}
    </>
  );
};

export default DropdownMenu;
